import React from 'react';
import { MenuItem } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { IShipmentListItem } from 'typings/shipment';
import { ClaimInsurance } from 'easyship-components/icons';
import MixpanelService from '@/utils/mixpanel.service';
import { useShowTypeModal } from '@/features/Claim/hooks/general/useShowTypeModal';
import { baseStyleIconBox } from '../styles';
import { SPEED_DIALS_MIXPANEL_EVENTS_NAMES } from '../speedDialsMixpanelEvents';

interface InsuranceClaimMenuItemProps {
  divider?: boolean;
  shipmentListItem: IShipmentListItem;
}

export default function InsuranceClaimMenuItem({
  divider = false,
  shipmentListItem,
}: InsuranceClaimMenuItemProps) {
  const { claimable: isClaimable } = shipmentListItem;

  const { showTypeModal } = useShowTypeModal();

  async function handleInsuranceClaim() {
    showTypeModal(shipmentListItem.easyship_shipment_id);
    MixpanelService.track(
      SPEED_DIALS_MIXPANEL_EVENTS_NAMES.fromShipmentDetailsPagePanel.claimInsurance,
      {
        easyship_shipment_id: shipmentListItem.easyship_shipment_id,
      }
    );
  }

  if (!isClaimable) {
    return null;
  }

  return (
    <MenuItem onClick={handleInsuranceClaim} divider={divider}>
      <div style={baseStyleIconBox}>
        <ClaimInsurance className="text-ink-100" />
      </div>
      <span className="text-base">
        <FormattedMessage id="shipments.speed-dial.claim-insurance" />
      </span>
    </MenuItem>
  );
}
